import { render, staticRenderFns } from "./component-bd673c97.vue?vue&type=template&id=61370497&scoped=true&"
import script from "./component-bd673c97.vue?vue&type=script&lang=js&"
export * from "./component-bd673c97.vue?vue&type=script&lang=js&"
import style0 from "./component-bd673c97.vue?vue&type=style&index=0&id=61370497&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61370497",
  null
  
)

export default component.exports